import {camelCase, upperFirst} from 'lodash-es';
import type {App, Plugin} from 'vue';

export default {
    install(app: App) {
        const componentFiles = import.meta.glob(
            ['@/app/**/aeg-*.vue'],
            { eager: true }
        );

        Object.entries(componentFiles).forEach(([path, componentConfig]) => {
            const componentName = upperFirst(
                camelCase(path.split('/').pop()?.replace(/\.\w+$/, '') ?? '')
            );

            app.component(
                `${componentName}`, (componentConfig as any).default
            );
        });
    },
} as Plugin;
